module.exports = function init_cta_subject() {

  let pending_subject = null;
  let pending_cta_text = null;

  // Capture the subject class (subject-*) and CTA text when a .trigger-contact-form is clicked
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.trigger-contact-form[class*="subject-"]');
    if (trigger) {
      const match = Array.from(trigger.classList).find(c => c.startsWith('subject-'));
      if (match) {
        pending_subject = match.replace('subject-', '');
      }
      pending_cta_text = trigger.textContent.trim();
    }
  }, true);

  function populate_subject(subject) {
    if (!subject) return;

    const $select = jQuery('.contact-subject select');
    const search = subject.toLowerCase().replace(/-/g, ' ');

    // Find the best matching option value from whatever is currently in the DOM
    const match = $select.find('option').filter(function() {
      return jQuery(this).val() &&
        jQuery(this).val().toLowerCase().includes(search) ||
        jQuery(this).text().toLowerCase().includes(search);
    }).first().val();

    if (match) {
      $select.val(match).trigger('chosen:updated');
    }
  }

  function populate_cta_source(text) {
    if (!text) return;
    jQuery('.cta-text input').val(text);
  }

  jQuery(document).on('pumAfterOpen', function(e) {
    setTimeout(function() {
      populate_subject(pending_subject);
      populate_cta_source(pending_cta_text);
      pending_subject = null;
      pending_cta_text = null;
    }, 100);
  });

}
